var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-yoga-layout",
    {
      staticClass: "clickable",
      attrs: {
        "width-auto": "1",
        "height-auto": "1",
        padding: "0.075",
        "flex-wrap": "wrap",
        "flex-direction": "column",
        "align-items": "center",
        "justify-content": "center",
        geometry: "primitive: rounded-plane;",
        material: "color: #001034;",
        "push-mesh-backwards": "distance: 0.02",
      },
    },
    [
      _c("a-image", {
        staticClass: "clickable",
        attrs: {
          src: "/aframe-assets/icons/cancel-padded.png",
          width: "0.07",
          height: "0.07",
          "yoga-layout-item": "position: absolute; right:0.07; top:0.07",
          "ui-icon": "",
          "toggle-modal": "#navigationPanel",
        },
      }),
      _vm._v(" "),
      _c(
        "a-yoga-layout",
        {
          attrs: {
            width: _vm.panelWidth,
            "height-auto": "1",
            "flex-wrap": "wrap",
            "flex-direction": "row",
            "align-items": "flex-start",
            "justify-content": "flex-start",
            padding: "0",
            geometry: "primitive: plane;",
            material: "visible: false",
          },
        },
        [
          _c(
            "a-entity",
            {
              attrs: {
                "html-dev": "",
                geometry: "primitive: plane; width:0; height: 0",
                material: "visible: false; transparent: true",
                "yoga-layout-item":
                  "margin: 0.04; marginEdge: left; padding: 0",
              },
            },
            [
              _c("div", { staticClass: "vr" }, [
                _c("h1", [_vm._v(_vm._s(_vm.$t("rooms_to_explore")))]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-yoga-layout",
        {
          attrs: {
            width: _vm.panelWidth,
            "height-auto": "1",
            "flex-wrap": "wrap",
            "flex-direction": "row",
            "align-items": "flex-start",
            "justify-content": "flex-start",
            padding: "0",
            geometry: "primitive: plane;",
            material: "visible: false",
          },
        },
        _vm._l(_vm.pages, function (_page) {
          return _c(
            "a-yoga-layout",
            {
              key: _page.id,
              staticClass: "clickable",
              attrs: {
                id: "image-" + _page.title,
                width: "0.35",
                height: "0.35",
                "flex-wrap": "nowrap",
                "flex-direction": "column",
                "align-items": "flex-start",
                "justify-content": "flex-start",
                geometry: "primitive: plane;",
                material: "visible: false;",
                margin: "0",
                padding: "0.05",
                "yoga-layout-item": "margin: 0.03; padding: 0.03",
                "hover-effect-scale": "scale: 1.15",
              },
              on: {
                click: function ($event) {
                  return _vm.selectPage(_page)
                },
              },
            },
            [
              _c("a-image", {
                attrs: {
                  src: _page.sky_thumbnail,
                  width: "0.35",
                  height: "0.26",
                  "yoga-layout-item": "margin: 0; marginEdge: all",
                },
              }),
              _vm._v(" "),
              _c(
                "a-entity",
                {
                  attrs: {
                    "html-dev": "autoEnable: false",
                    geometry: "primitive: plane; width:0.35; height: 0.1",
                    material: "visible: false; transparent: true",
                    "yoga-layout-item":
                      "margin: 0; marginEdge: all; padding: 0",
                  },
                },
                [
                  _c("div", { staticClass: "vr uxk-text-center" }, [
                    _vm.currentPage && _page.id !== _vm.currentPage.id
                      ? _c("span", { staticClass: "link" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_page.title) +
                              "\n                  "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPage && _page.id === _vm.currentPage.id
                      ? _c("strong", { staticClass: "link" }, [
                          _vm._v(
                            "\n            » " +
                              _vm._s(_page.title) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }